var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTestTypeCycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2645_37035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "#2B4B8E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2645_37035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2 17.2008C9.41503 17.2008 10.4 16.2158 10.4 15.0008C10.4 13.7858 9.41503 12.8008 8.2 12.8008C6.98497 12.8008 6 13.7858 6 15.0008C6 16.2158 6.98497 17.2008 8.2 17.2008Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8016 17.2008C17.0166 17.2008 18.0016 16.2158 18.0016 15.0008C18.0016 13.7858 17.0166 12.8008 15.8016 12.8008C14.5865 12.8008 13.6016 13.7858 13.6016 15.0008C13.6016 16.2158 14.5865 17.2008 15.8016 17.2008Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1953 8C14.7476 8 15.1953 7.55228 15.1953 7C15.1953 6.44772 14.7476 6 14.1953 6C13.643 6 13.1953 6.44772 13.1953 7C13.1953 7.55228 13.643 8 14.1953 8Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9965 16.0004V13.2004L10.3453 11.8804C10.3014 11.8453 10.2654 11.8013 10.2397 11.7512C10.2139 11.7012 10.199 11.6463 10.1959 11.5902C10.1928 11.534 10.2016 11.4778 10.2217 11.4253C10.2418 11.3727 10.2728 11.325 10.3125 11.2852L12.4805 9.11724C12.5203 9.07745 12.568 9.04649 12.6206 9.02639C12.6731 9.0063 12.7293 8.99751 12.7855 9.00061C12.8417 9.0037 12.8965 9.01861 12.9466 9.04436C12.9966 9.07011 13.0406 9.10612 13.0757 9.15004L14.3965 10.8004H15.9965",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2645_37035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2645_37035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8,
    height: 12.8,
    fill: "white",
    transform: "translate(5.60156 5.19922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestTypeCycle);
export default __webpack_public_path__ + "static/media/icon-test-type-cycle.16f8f0bce4c43e9c8a3aab864f0b88ed.svg";
export { ForwardRef as ReactComponent };